module.exports = __webpack_public_path__ + "chat_white_full.17577a2af9813d45728c.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/chat_white_full.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/chat_white_full.svg
// module chunks = styles